import { filterPage } from "components/common/Filters/FiltersHelper";
import Bookmark from "components/features/library/Bookmark";
import AllPlans from "./allPlans";

export const libraryTabDetails = [
  {
    label: "All Plans ",
    content: AllPlans,
    filtersToClear: [filterPage.libraryAllPlansDisplay]
  },
  {
    label: "Bookmarked",
    content: Bookmark,
    filtersToClear: [filterPage.libraryBookmarkedPlansDisplay]
  }
];
